<!--统计-->
<template>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/admin/stock'}">{{msg('报关资料')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('统计')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="10"  class="ctrl-wrap">
            <el-col :sm="24" :md="4">
                <el-button size="mini"
                    @click="doReport(1)" type="primary" 
                    plain
                >
                    <i class="el-icon-search" style="display:inline-block;margin-right:4px;"></i>
                    <transition name="el-fade-in-linear">
                        <span v-show="!isMinScreen">{{msg('未锁定统计')}}</span>
                    </transition>
                </el-button>
            </el-col>
            <el-col :sm="24" :md="4">
                <el-button size="mini"
                    @click="doReport(2)" type="primary" 
                    plain
                >
                    <i class="el-icon-search" style="display:inline-block;margin-right:4px;"></i>
                    <transition name="el-fade-in-linear">
                        <span v-show="!isMinScreen">{{msg('当前锁定统计')}}</span>
                    </transition>
                </el-button>
            </el-col> 
            <el-col :sm="24" :md="4">
                <el-button size="mini"
                    @click="doReport(3)" type="primary" 
                    plain
                >
                    <i class="el-icon-search" style="display:inline-block;margin-right:4px;"></i>
                    <transition name="el-fade-in-linear">
                        <span v-show="!isMinScreen">{{msg('锁定待调用统计')}}</span>
                    </transition>
                </el-button>
            </el-col>   
        </el-row>
        <el-row :gutter="15">
            <el-table :data="datas"
                border
                max-height="400"
             style="width: 100%" size="mini" ref="dataTable" stripe>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="expCompany" :label="msg('配送方式')" min-width="120" :show-overflow-tooltip="true" sortable>
                </el-table-column>
                <el-table-column prop="expCod" :label="msg('配送类别')" min-width="100" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-tag
                        :type="scope.row.expCod == 1 ? 'danger' : scope.row.expCod == 3 ? 'success' : 'primary' "
                        disable-transitions>{{scope.row.expCod == 1? '貨到付款' : scope.row.expCod == 3 ? '純配送' : '无'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="allnullCount" :label="msg('非实名')" min-width="100" :show-overflow-tooltip="true" sortable>
                </el-table-column>
                <el-table-column prop="allHasCount" :label="msg('实名')" min-width="100" :show-overflow-tooltip="true" sortable>
                </el-table-column>
                <el-table-column prop="nullNameCount" :label="msg('专用')" min-width="100" :show-overflow-tooltip="true" sortable>
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
export default {
    name: 'WalletImport',
    components: {},
    data(){
        return {
            datas:[],
        }
    },
    computed: {
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    mounted(){
        this.datas = [];
    },
    methods:{
        init(){
            this.datas = [];
        },
        doReport(type){
            this.$axios.post(this.$kit.api.declare.doCount+"?t="+type)
                .then((result) => {
                    if(result.status){
                        this.datas = result.data;
                    }
                });
        },
    }
}
</script>
<style lang="scss" scoped>

</style>